import { render, staticRenderFns } from "./zenga-new-flats-card.vue?vue&type=template&id=21b9bf0c&scoped=true&lang=pug"
import script from "./zenga-new-flats-card.vue?vue&type=script&setup=true&lang=js"
export * from "./zenga-new-flats-card.vue?vue&type=script&setup=true&lang=js"
import style0 from "./zenga-new-flats-card.vue?vue&type=style&index=0&id=21b9bf0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b9bf0c",
  null
  
)

export default component.exports